import styles from "./BrandInfo.module.scss";
import classNames from "classnames/bind";
import { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faAngleDown,
    faAngleUp,
    faArrowUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // optional
import { Helmet } from "react-helmet";
const cx = classNames.bind(styles);
function BrandInfo({ data }) {
    console.log("BrandInfo");
    const pRef = useRef();
    const moreRef = useRef();
    if (moreRef.current && moreRef.current.classList.contains(cx("active"))) {
        pRef.current.classList.remove(cx("view_more"));
        moreRef.current.classList.remove(cx("active"));
    }
    const handleParagrap = (e) => {
        e.target.classList.toggle(cx("active"));
        pRef.current.classList.toggle(cx("view_more"));
    };
    setTimeout(() => {
        pRef.current && (pRef.current.innerHTML = data.description);
    }, 0);
    return (
        <>
            <Helmet>
                <title>{`Thông tin dòng xe, hãng xe ${data.brand} - Vũ Trụ Siêu Xe`}</title>
                {/* <meta
                    name="description"
                    content={`Tất tần tật về hãng siêu xe ${data.brand} và các siêu xe được ${data.brand} sản xuất`}
                /> */}
                <meta name="keywords" content={data.brand} />
            </Helmet>
            <div className={cx("brand_wrap")}>
                <div className={cx("more")}></div>
                <div className={cx("brand_logo")}>
                    <img
                        src={data.avatar}
                        alt={`Logo thương hiệu ${data.brand}`}
                    />
                </div>
                <h2>
                    {data.brand}{" "}
                    <Tippy
                        placement="bottom"
                        content={`Đến trang chính thức của ${data.brand}`}
                    >
                        <a
                            href={data.home}
                            target="_blank"
                            rel="noreferrer"
                            className={cx("brand_ex")}
                        >
                            <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                        </a>
                    </Tippy>
                </h2>
                <p ref={pRef}></p>
            </div>
            <div
                ref={moreRef}
                onClick={handleParagrap}
                className={cx("load_more")}
            >
                <div className={cx("more_btn")}>
                    <p>Xêm thêm</p>
                    <i>
                        <FontAwesomeIcon icon={faAngleDown} />
                    </i>
                </div>
                <div className={cx("less_btn")}>
                    <i>
                        <FontAwesomeIcon icon={faAngleUp} />
                    </i>
                    <p>Ẩn bớt</p>
                </div>
            </div>
        </>
    );
}

export default BrandInfo;
